export default "__VITE_ASSET__Cg7H6BEu__"